import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Footer from '../../components/Footer';
import HeroSection from './components/HeroSection';
import FeaturedProjects from './components/FeaturedProjects';
import SkillsVisualization from './components/SkillsVisualization';
import LatestThoughts from './components/LatestThoughts';
import SocialProof from './components/SocialProof';

const HomepageInteractiveDeveloperShowcase = () => {
  useEffect(() => {
    // Smooth scroll behavior for anchor links
    const handleSmoothScroll = (e) => {
      const href = e.target?.getAttribute('href');
      if (href && href.startsWith('#')) {
        e.preventDefault();
        const element = document.querySelector(href);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    };

    document.addEventListener('click', handleSmoothScroll);
    return () => document.removeEventListener('click', handleSmoothScroll);
  }, []);

  return (
    <>
      <Helmet>
        <title>Arvin Zojaji - Full-Stack Developer & Digital Craftsperson</title>
        <meta 
          name="description" 
          content="Passionate full-stack developer specializing in React, Node.js, and modern web technologies. Creating scalable applications and intuitive user experiences that solve real-world problems." 
        />
        <meta name="keywords" content="full-stack developer, React developer, Node.js, web development, portfolio, JavaScript, TypeScript, frontend, backend" />
        <meta name="author" content="Arvin Zojaji" />
        
        {/* Open Graph */}
        <meta property="og:title" content="Arvin Z's Portfolio - Full-Stack Developer" />
        <meta property="og:description" content="Passionate full-stack developer creating digital experiences that solve real-world problems." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://arvinz.net" />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Arvin Z's Portfolio - Full-Stack Developer" />
        <meta name="twitter:description" content="Passionate full-stack developer creating digital experiences that solve real-world problems." />
        
        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Person",
            "name": "Arvin Z's Portfolio",
            "jobTitle": "Full-Stack Developer",
            "description": "Passionate full-stack developer specializing in React, Node.js, and modern web technologies",
            "url": "https://arvinz.net",
            "sameAs": [
              "https://github.com/arvinzojaji",
              "https://linkedin.com/in/arvin-zojaji"
            ]
          })}
        </script>
      </Helmet>

      <div className="min-h-screen bg-background">
        {/* Header */}
        <Header />

        {/* Main Content */}
        <main className="pt-16">
          {/* Hero Section */}
          <HeroSection />

          {/* Featured Projects */}
          <FeaturedProjects />

          {/* Skills Visualization */}
          <SkillsVisualization />

          {/* Latest Thoughts */}
          <LatestThoughts />

          {/* Social Proof */}
          <SocialProof />
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </>
  );
};

export default HomepageInteractiveDeveloperShowcase;